import React, { useContext } from 'react';
import { LogPageEventProps } from './ClickStreamModel';
export interface ClickStream {
	logViewPage?: (e?: any) => void;
	logPageEvent: (e: LogPageEventProps) => void;
}
export const ClickStreamContext = React.createContext<ClickStream>({
	logPageEvent: () => {},
});
export const useClickStreamContext = () => useContext(ClickStreamContext);
